import _ from 'lodash'
import moment from 'moment'
import GalleryItem from '@/modules/cms/modules/gallery/model/GalleryItem';
import KeyValuePair from '@/modules/core/support/KeyValuePair'
import {MediaObject} from '@/modules/media/types';

/**
 * Galería
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
export default class Gallery {
    public readonly tempId = _.uniqueId('gallery_')
    public createdAt = new Date()
    public updatedAt = new Date()
    public items: GalleryItem[] = []
    public itemCount = 0

    private _previewMedia: MediaObject[] = []

    /**
     * Permite acceder a los archivos multimedia que serán utilizados para mostrar la vista
     * previa de la galería
     */
    public get previewMedia (): MediaObject[] {
        return this._previewMedia.length
            ? this._previewMedia
            : this.items.slice(0, 4).map(i => i.media)
    }

    /**
     * Indica si la galería es nueva y todavía no ha sido registrada en
     * el servidor
     */
    public get isNew (): boolean {
        return !this.id
    }

    /**
     * Constructor
     *
     * @param id
     * @param name
     */
    constructor (public readonly id = 0, public name = '') {}

    /**
     * Convierte la información plana en una entidad
     * @param data
     */
    public static deserialize (data: KeyValuePair) {
        const gallery = new this(data.id, data.name)
        gallery.createdAt = moment(data.created_at, 'DD/MM/YYYY HH:mm:ss').toDate()
        gallery.updatedAt = moment(data.created_at, 'DD/MM/YYYY HH:mm:ss').toDate()
        gallery.items = (data.items || []).map((i: KeyValuePair) => GalleryItem.deserialize(i))
        gallery.itemCount = data.item_count || gallery.items.length
        if (Array.isArray(data.preview_media)) {
            gallery._previewMedia = data.preview_media.map(m => MediaObject.convert(m))
        }

        return gallery
    }

    public serialize () {
        return {
            name: this.name,
            items: this.items.map(i => i.serialize()),
        }
    }
}
